/* eslint-disable */
import { SVGProps } from "react";

const SvgGenerators = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-name="generator (1)"
    xmlns="http://www.w3.org/2000/svg"
    width={42.903}
    height={40.21}
    fill="currentColor"
    viewBox="0 0 42.903 40.21"
    {...props}
  >
    <path
      data-name="Path 570"
      d="M.012 40.21H9.42l2.513-2.513h19.05l2.513 2.513h9.408v-7.539H.012Zm0 0"
    />
    <path
      data-name="Path 571"
      d="M21.458 12.566a6.283 6.283 0 1 0 6.283 6.283 6.285 6.285 0 0 0-6.283-6.283Zm1.181 10.454-2.362-.8.7-2.111h-2.509l1.809-5.428 2.362.8-.7 2.111h2.513Zm0 0"
    />
    <path
      data-name="Path 572"
      d="M.012 7.54v22.618h42.891V7.54Zm21.445 20.1a8.8 8.8 0 1 1 8.8-8.8 8.806 8.806 0 0 1-8.799 8.805Zm0 0"
    />
    <path
      data-name="Path 573"
      d="M2.609 5.026h10.053V2.513h2.513V0H.012v2.513h2.6Zm0 0"
    />
  </svg>
);

export default SvgGenerators;
